import React from 'react';
import { NavItem, NavLink } from 'reactstrap';
import styled from 'styled-components';
import { partial } from 'lodash';
import theme from '../../assets/css/theme';
import { CARD_PADDING } from '../NewDesign/Card';
import { TAB_BORDER_WIDTH } from './constants';

const NavItemStyled = styled(NavItem)`
  &:has(.active) {
    ${(props) =>
      (props.$newDesign || props.$redesign) &&
      `border-bottom: ${TAB_BORDER_WIDTH}px solid ${theme.commonColors.second};
      margin-bottom: -${TAB_BORDER_WIDTH}px;`}
  }

  &:first-child {
    ${(props) => props.$newDesign && `margin-left: ${CARD_PADDING}px;`}
    // Matches the 48px side padding of the design tab's Content wrapper so the
    // first tab lines up with the panel headings below it.
    ${(props) => props.$redesign && 'margin-left: 48px;'}
  }

  &:not(:first-child) {
    ${(props) => (props.$newDesign || props.$redesign) && 'margin-left: 3rem;'}
  }
`;

const NavLinkStyled = styled(NavLink)`
  text-transform: capitalize;
  background-color: transparent;
  color: ${theme.textColors.baseText};
  padding: 0.5rem;
  border: none !important;
  font-size: 14px;
  &.nav-link.active {
    ${(props) => (props.$newDesign || props.$redesign ? 'font-weight: 400;' : 'font-weight: 600;')}
    background-color: transparent;
    color: ${theme.commonColors.second};
  }
  ${(props) =>
    props.$newDesign &&
    `color: #ACACAC;
    font-size: 1.25rem;
    font-weight: 300;`}
  ${(props) =>
    props.$redesign &&
    `color: #ACACAC;
    font-size: ${theme.fontSizes.tab};
    font-weight: 300;
    display: flex;
    align-items: center;
    height: 45px;
    box-sizing: border-box;
    padding: 12px 0.5rem 18px;`}
`;

const WarningDot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #f86c6b;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  margin-left: 6px;
  line-height: 1;
  vertical-align: middle;
  flex-shrink: 0;
`;

interface IProps {
  name: string;
  onClick: (name: string) => void;
  isActive: boolean;
  className?: string;
  newDesign?: boolean;
  /** newDesign feature-flag styling; see TabsHeader's `redesign` prop. */
  redesign?: boolean;
  warning?: boolean;
}

export const TabItem = ({
  name,
  onClick,
  isActive,
  className,
  newDesign,
  redesign,
  warning,
  ...props
}: IProps) => {
  if (isActive) className = `active ${className}`;

  return (
    <NavItemStyled $newDesign={newDesign} $redesign={redesign}>
      <NavLinkStyled
        onClick={partial(onClick, name)}
        className={className}
        $newDesign={newDesign}
        $redesign={redesign}
        {...props}
      >
        {name}
        {warning && <WarningDot>!</WarningDot>}
      </NavLinkStyled>
    </NavItemStyled>
  );
};

export default TabItem;
